import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "moc_categories";

export const getMocCategoriesList = async (
	currentTenantKey: string,
	filter: any = {}
) => {
	try {
		const response = await axios.get(`${url}/${currentTenantKey}/${apiURL}`, {
			params: { filter: JSON.stringify(filter) },
			...AuthHeader,
		});
		return response.data ?? [];
	} catch (error: any) {
		throw new Error(error.response.data.error);
	}
};

export const addMocCategory = async (currentTenantKey: string, data: any) => {
	try {
		const response = await axios.post(
			`${url}/${currentTenantKey}/${apiURL}`,
			data,
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};

export const updateMocCategory = async (
	currentTenantKey: string,
	_id: string,
	data: any
) => {
	try {
		const req_body = {
			filter: { _id: _id },
			data: data,
			options: { upsert: true, new: true },
		};
		const response = await axios.put(
			`${url}/${currentTenantKey}/${apiURL}`,
			req_body,
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};

// Saves one category's position in the drag-ordered list. Scoped to its _id
// and never upserts, so a category deleted meanwhile isn't recreated.
export const setMocCategoryOrder = async (
	currentTenantKey: string,
	_id: string,
	order: number
) => {
	try {
		const req_body = {
			filter: { _id: _id },
			data: { order: order },
			options: { upsert: false, new: true },
		};
		const response = await axios.put(
			`${url}/${currentTenantKey}/${apiURL}`,
			req_body,
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error?.message ?? "Failed to save the category order");
	}
};

export const deleteMocCategory = async (
	currentTenantKey: string,
	_id: string
) => {
	try {
		const response = await axios.delete(
			`${url}/${currentTenantKey}/${apiURL}`,
			{ params: { filter: JSON.stringify({ _id: _id }) }, ...AuthHeader }
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};
